const TEN_MINUTES_MS = 10 * 60 * 1000

/**
 * Shared by the `contracts-v2/$subscriptionId` loader's prefetch and the fiscal attestations section's
 * `useQuery`. Both need `gcTime`: the global client runs `gcTime: 0`, which evicts an observer-less prefetch
 * before the component mounts, and the section decides whether it exists at all from this data. `staleTime`
 * is safe here only because attestations are archived once a fiscal year.
 *
 * See `routing-frontend.md`, "A section whose existence depends on its data", for how the value is sized and
 * why `retry` is deliberately absent.
 */
export const CONTRACT_DOCUMENTS_QUERY_OPTIONS = { gcTime: TEN_MINUTES_MS, staleTime: TEN_MINUTES_MS }
